<div class="container-fluid">
    <div class="row mt-4">
        <mat-card-title>
            <h2 class="mt-3 mb-0" tourAnchor="dashboard.list">
                Sites by Status
            </h2>
        </mat-card-title>

        <mat-card-subtitle class="mb-0"
            >Showing all sites grouped by their status for the current year to
            date.</mat-card-subtitle
        >

        @if (siteStatuses.length) { @for (status of siteStatuses; track status.name)
        {
        <div class="col-md-3 col-sm-6 col-xs-12">
            <a class="stat-card stat-card--link mt-3" [style.--accent]="status.data.background" routerLink="/app/sites" [queryParams]="siteStatusQueryParams(status)">
                <div class="stat-card__text">
                    <span class="stat-card__label">{{ status.name | titlecase }}</span>
                    <span class="stat-card__sub">Sites</span>
                </div>
                <div class="stat-card__count">
                    <span class="stat-card__total">{{ status.total }}</span>
                </div>
            </a>
        </div>
        } } @else { @for (_ of [].constructor(8); track $index; let i = $index) {
        <div class="col-md-3 col-sm-6 col-xs-12">
            <ngx-skeleton-loader
                [theme]="{
                    width: '100%',
                    height: '80px',
                    'margin-top': '16px',
                    'margin-bottom': '0',
                    'background-color': skeletonBackground
                }"
                count="1"
                [animation]="skeletonTheme"
            ></ngx-skeleton-loader>
        </div>
        } }
    </div>

    @if (maintenanceItems.length) {
        <div class="row">
            <div class="col-12">
                <mat-card class="mt-3 maintenance-due-card">
                    <mat-card-title class="maintenance-card-title">
                        <span>Maintenance Due</span>
                        <a mat-stroked-button color="primary" routerLink="/app/maintenance">View upcoming</a>
                    </mat-card-title>
                    <mat-card-subtitle>{{ maintenanceTotal }} accessible item{{ maintenanceTotal === 1 ? '' : 's' }} overdue or due in the next 30 days.</mat-card-subtitle>
                    <mat-card-content>
                        <div class="maintenance-site-grid">
                            @for (site of maintenanceBySite; track site.id) {
                                <a class="maintenance-site" routerLink="/app/maintenance" [queryParams]="{site_id: site.id}">
                                    <span><strong>{{ site.name }}</strong><br><small>{{ site.overdue ? site.overdue + ' overdue' : 'Upcoming' }}</small></span>
                                    <span class="maintenance-count">{{ site.count }}</span>
                                </a>
                            }
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    }

    <div class="row">
        <div class="col-12 col-md-8">
            <mat-card class="mt-3" tourAnchor="dashboard.latest-pin-activity">
                <mat-card-title>
                    <h2>Latest Pin Activity</h2>
                </mat-card-title>

                <mat-card-subtitle
                    >Showing the latest pin activity across all sites for the
                    last 7 days.</mat-card-subtitle
                >

                <mat-card-content>
                    <ng-container>
                        @if (('view_pins' | hasPermission)) {
                        <table
                            mat-table
                            [dataSource]="latestPinActivity"
                            class="w-100"
                        >
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let pin">
                                    {{ pin.identifier }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let pin">
                                    @if (pin.latest_history?.status || pin.status) {
                                    <span
                                        class="badge"
                                        [style.background]="
                                            pin.latest_history?.status?.background || pin.status?.background
                                        "
                                        [style.color]="pin.latest_history?.status?.colour || pin.status?.colour"
                                    >
                                        {{ (pin.latest_history?.status?.title || pin.status?.title) | titlecase }}
                                    </span>
                                    }
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="site">
                                <th mat-header-cell *matHeaderCellDef>Site</th>
                                <td mat-cell *matCellDef="let pin">
                                    {{ pin.site }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="author">
                                <th mat-header-cell *matHeaderCellDef>
                                    Author
                                </th>
                                <td mat-cell *matCellDef="let pin">
                                    {{ pin.author }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="updated_at">
                                <th mat-header-cell *matHeaderCellDef>
                                    Last Updated
                                </th>
                                <td mat-cell *matCellDef="let pin">
                                    {{ pin.updated_at | date }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="navigation">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let pin" class="latest-pin-activity-navigation-cell" aria-hidden="true">
                                    <mat-icon class="latest-pin-activity-chevron">chevron_right</mat-icon>
                                </td>
                            </ng-container>
                            <tr
                                mat-header-row
                                *matHeaderRowDef="displayedColumns"
                            ></tr>
                            <tr
                                mat-row
                                class="latest-pin-activity-row"
                                *matRowDef="let row; columns: displayedColumns"
                                (click)="openPin(row?.id)"
                            ></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td
                                    class="mat-cell"
                                    colspan="9999"
                                    style="text-align: center;"
                                >
                                    <i>No Pins were found...</i>
                                </td>
                            </tr>
                        </table>

                        <tfoot>
                            <mat-paginator
                                [length]="totalRows"
                                [pageIndex]="currentPage"
                                [pageSize]="pageSize"
                                [pageSizeOptions]="pageSizeOptions"
                                (page)="pinActivityPageChanged($event)"
                                aria-label="Select page"
                            >
                            </mat-paginator>
                        </tfoot>
                        } @else {
                        <h4 style="text-align: center;">
                            You do not have permission to view pins.
                        </h4>
                        }
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-12 col-md-4">
            <mat-card
                class="mt-3"
                tourAnchor="dashboard.latest-operative-activity"
            >
                <mat-card-title>
                    <h2>Latest Operative Activity</h2>
                </mat-card-title>

                <mat-card-subtitle
                    >Showing the latest operative activity across all sites for
                    the last 7 days.</mat-card-subtitle
                >

                <mat-card-content>
                    <table
                        mat-table
                        [dataSource]="latestOperativeActivity"
                        class="w-100"
                    >
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Name</th>
                            <td mat-cell *matCellDef="let opererative">
                                {{ opererative.name }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef>Total</th>
                            <td mat-cell *matCellDef="let opererative">
                                {{ opererative.total }}
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumnsLOA"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumnsLOA"
                        ></tr>
                        <tr class="mat-row" *matNoDataRow>
                            <td
                                class="mat-cell"
                                colspan="9999"
                                style="text-align: center;"
                            >
                                <i>No Operatives were found...</i>
                            </td>
                        </tr>

                        <tfoot>
                            <mat-paginator
                                [length]="totalRowsLOA"
                                [pageIndex]="currentPageLOA"
                                [pageSize]="pageSizeLOA"
                                [pageSizeOptions]="pageSizeOptionsLOA"
                                (page)="operativeActivityPageChanged($event)"
                                aria-label="Select page"
                            >
                            </mat-paginator>
                        </tfoot>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
